// Copied from Components/header.jsx, which the PDF renders and must stay untouched.
import { asFile } from "./fileActions";

export const downloadShipmentFile = async (shipment, type) => {
  try {
    const url =
      type === "Label"
        ? shipment?.single_shipping_labels?.file
        : shipment?.single_shipping_invoice?.file;

    if (!url) return;

    const response = await fetch(url, {
      method: "GET",
      headers: { "Content-Type": "application/pdf" },
    });
    const blob = await response.blob();
    const objectUrl = window.URL.createObjectURL(new Blob([blob]));

    const link = document.createElement("a");
    link.href = objectUrl;
    link.setAttribute(
      "download",
      `${shipment?.tattension} ${shipment?.shipment_tracking_id} ${type}.pdf`,
    );
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  } catch (error) {
    console.error("Error downloading shipment file:", error);
  }
};

export const downloadMultipleFiles = async (files, trackingId) => {
  try {
    files?.forEach(async (label, index) => {
      const response = await fetch(label.file, {
        method: "GET",
        headers: { "Content-Type": "application/pdf" },
      });
      const blob = await response.blob();
      const url = window.URL.createObjectURL(new Blob([blob]));
      const fileExtension = label.file.split(".").pop();

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `${trackingId}_${label.type}_${index + 1}.${fileExtension}`,
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  } catch (error) {
    console.error("Error downloading labels:", error);
  }
};

const fetchBlob = async (url) => {
  const response = await fetch(url, {
    method: "GET",
    headers: { "Content-Type": "application/pdf" },
  });
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  return response.blob();
};

/**
 * The shipment's label or declaration ("Label" / "Declaration") as files,
 * for the order view's Print / Open / Share / Download menu: a manual
 * shipment's uploaded files when it has them, the shipment's own file
 * otherwise. Named as the downloads above name them.
 */
export const fetchShipmentFiles = async ({
  shipment,
  manualFiles,
  trackingId,
  type,
}) => {
  if (manualFiles?.length) {
    return Promise.all(
      manualFiles.map(async (entry, index) => {
        const blob = await fetchBlob(entry.file);
        const extension = String(entry.file).split(".").pop();
        return asFile(
          blob,
          `${trackingId}_${entry.type}_${index + 1}.${extension}`,
        );
      }),
    );
  }
  const url =
    type === "Label"
      ? shipment?.single_shipping_labels?.file
      : shipment?.single_shipping_invoice?.file;
  if (!url) return [];
  const blob = await fetchBlob(url);
  return [
    asFile(
      blob,
      `${shipment?.tattension} ${shipment?.shipment_tracking_id} ${type}.pdf`,
    ),
  ];
};
